import { render, staticRenderFns } from "./MotorInfoMenu.vue?vue&type=template&id=87781f66&scoped=true"
import script from "./MotorInfoMenu.vue?vue&type=script&lang=js"
export * from "./MotorInfoMenu.vue?vue&type=script&lang=js"
import style0 from "./MotorInfoMenu.vue?vue&type=style&index=0&id=87781f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87781f66",
  null
  
)

export default component.exports